import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { plantDetailLayoutRoute } from "./route";

import { NestedRouteErrorComponent } from "@/components/organisms/ErrorBoundary/NestedRouteErrorComponent";
import type { HistogramId } from "@/components/organisms/HistogramsRow";

/** Search params for the Analysis page (used for filtering from Dashboard) */
interface AnalysisSearchParams {
  filterChart?: HistogramId;
  filterIndex?: number;
  /** Composite "ncuName:tcuName" identifiers for pre-selecting devices from DayDetail */
  tcuIds?: string[];
}

export const plantAnalysisRoute = createRoute({
  path: "analysis",
  getParentRoute: () => plantDetailLayoutRoute,
  validateSearch: (search: Record<string, unknown>): AnalysisSearchParams => {
    const filterChart = search.filterChart as HistogramId | undefined;
    const filterIndex =
      typeof search.filterIndex === "number" ? search.filterIndex : undefined;
    const tcuIds = Array.isArray(search.tcuIds)
      ? (search.tcuIds as string[]).filter((n) => typeof n === "string")
      : undefined;

    return {
      filterChart:
        filterChart === "soc" ||
        filterChart === "angle" ||
        filterChart === "availability"
          ? filterChart
          : undefined,
      filterIndex,
      tcuIds: tcuIds && tcuIds.length > 0 ? tcuIds : undefined,
    };
  },
  component: lazyRouteComponent(async () => {
    const m = await import("./AnalysisPage/AnalysisPage");
    return { default: m.AnalysisPage };
  }),
  errorComponent: NestedRouteErrorComponent,
});
